import React from "react";
import { Box, Typography } from "@mui/material";
import { INK, MONO_FONT } from "./cardChrome";

/**
 * Facts of a resource as tiles: a small grey label above a bold value, laid
 * out in as many columns as fit (the review panel's row typography, side by
 * side). A fact without a value is skipped.
 *
 * facts: [{ key?, label, value, mono? }]
 */
export default function FactTiles({ facts, minWidth = 150 }) {
  const shown = facts.filter((fact) => fact.value !== null && fact.value !== undefined && fact.value !== "");
  if (shown.length === 0) return null;
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`,
        gap: 2,
        width: "100%",
      }}
    >
      {shown.map((fact) => (
        <Box key={fact.key || fact.label} sx={{ minWidth: 0 }}>
          <Typography variant="caption" sx={{ display: "block", lineHeight: 1.2, color: "text.secondary" }}>
            {fact.label}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: INK,
              overflowWrap: "anywhere",
              fontFamily: fact.mono ? MONO_FONT : (theme) => theme.typography.fontFamily,
              fontSize: fact.mono ? "0.8rem" : undefined,
            }}
          >
            {fact.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
